import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import lodash from "lodash";
import ProviderManager from "../../../../provider/providerManager";
import { formatDeliveryTimeSlots } from "../../../../utilities/dateUtils";
import { regexPatterns } from "../../../../utilities/validation/validationVariables";
import {
  validateField,
  validateFields,
} from "../../../../utilities/validation/validator";

export const getDeliveryNoProducts = createAsyncThunk(
  "updateDeliverySlot/getDeliveryNoProducts",
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData(
        "getDeliverySlotsNoProd",
        [
          data.city,
          data.street,
          data.homeNum,
          data.slotTimeNoteOrder,
          data.slotTimeDate,
          data.slotTimeFrom,
        ],
      );
      return result;
    } catch (error) {
      return error;
    }
  },
);

export const updateOrCancel = createAsyncThunk(
  "BussinessCustomer/UpdateOrCancelBusinessDelivery",
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData(
        "UpdateOrCancelBusinessDelivery",
        [
          data.Ban,
          data.DispatchOrder,
          data.NoteOrder,
          data.deliveryRequestAction,
          data.NewCity,
          data.NewStreet,
          data.NewHome,
          data.NewApartment,
          data.NewDeliveryDate,
          data.NewRoundFrom,
          data.NewRoundTo,
          data.UserName,
          data.PhoneForDelivery,
          data.PhoneForDelivery2,
          data.PickLocation,
          data.Round,
          data.Comments,
          data.IsBusiness,
          data.SubscriberNoOrIMEI,
          data.IsPrivate,
        ],
      );
      return result;
    } catch (error) {
      props.setIsShowFail(true);
      return error;
    }
  },
);

const initialState = {
  form: {
    deliveryTime: "",
    deliveryTimePlaceholder: "",
    round: "",
    roundName: "",
    waitFrom: "",
    waitTo: "",
    lfdat: "",
    weekdayL: "",
    pickLocation: "",
    userName: "",
    phone: "",
    phone2: "",
    comments: "",
    isLoading: true,
    errorObj: "",
    valid: "",
    errors: {},
    rules: {
      deliveryTime: {
        required: { value: true, error: "לא נבחר מועד" },
      },
      userName: {
        required: { value: true, error: "לא הוזן שם פרטי" },
        pattern: { value: regexPatterns.lettersRegex, error: "ערך לא תקין" },
        minLength: { value: 5, error: "יש להזין לפחות 5 תווים" },
        maxLength: { value: 50, error: "השם שהוזן ארוך מדי" },
      },
    },
  },
  deliveryTimeSlots: [],
  populatedCity: "",
  populatedStreet: "",
  populatedHome: "",
  elementIndex: "",
  isEdit: false,
  isSubmit: false,
  updateSuccess: "",
  isApprovePopupShowBusiness: "",
  isShowFail: false,
  isSavedSuccessfullyVisible: false,
};

const UpdateBusinessDeliverySlotSlice = createSlice({
  name: "updateBusinessDeliverySlot",
  initialState: initialState,
  reducers: {
    endProcess: (state) => initialState,
    deliveryValidateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return { payload: validate };
      },
    },

    clearForm: {
      reducer(state, action) {
        state.form.phone = "";
        state.form.phone2 = "";
        state.form.userName = "";
        state.form.comments = "";
        state.form.deliveryTime = "";
      },
    },

    clearTimeSlots: {
      reducer(state, action) {
        state.form.deliveryTime = "בחר מועד";
      },
    },

    setIsShowFail: {
      reducer(state, action) {
        state.isShowFail = action.payload;
      },
    },

    clearValid: {
      reducer(state, action) {
        state.form.valid = false;
      },
    },

    setUpdateOrCancelMode: {
      reducer(state, action) {
        state.mode = action.payload;
      },
    },

    setIsNewAddress: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload.form);
        form.isNewAddress = payload.value;
        return { payload: form };
      },
    },
    startLoading: {
      reducer(state, action) {
        state.form.isLoading = action.payload;
      },
    },
    deliveryChangeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        form.round = payload.target.round;
        form.roundName = payload.target.roundName;
        form.waitFrom = payload.target.waitFrom;
        form.waitTo = payload.target.waitTo;
        form.lfdat = payload.target.lfdat;
        form.weekdayL = payload.target.weekdayL;
        form.pickLocation = payload.target.pickLocation;

        const validate = validateField(form, name, value);

        return { payload: validate };
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return { payload: validate };
      },
    },
    expandElement: {
      reducer(state, action) {
        if (state.elementIndex === action.payload) {
          state.elementIndex = "";
        } else {
          state.isEdit = false;
          state.form.phone = "";
          state.form.phone2 = "";
          state.form.userName = "";
          state.form.comments = "";
          state.form.deliveryTime = "";
          state.elementIndex = action.payload;
        }
      },
    },
    enableEdit: {
      reducer(state, action) {
        console.log(action);
        if (state.isEdit === false) {
          if (state.form.userName === "") {
            if (action.payload.contactNo1 !== undefined) {
              state.form.phone = action.payload.contactNo1;
              state.form.phone2 = action.payload.contactNo2;
            }
            if (
              state.form.deliveryTime === "" ||
              state.form.deliveryTime == "בחר מועד"
            ) {
              state.form.deliveryTime =
                action.payload.dayOfWeek +
                " " +
                action.payload.disptachDate +
                "\xa0 \xa0" +
                action.payload.roundFrom +
                " - " +
                action.payload.roundTo;
            }
            state.form.userName = action.payload.customerName;
            state.populatedCity = action.payload.city;
            state.populatedStreet = action.payload.street;
            state.form.comments = action.payload.messengerText;
          }
          state.isEdit = true;
        } else {
          state.isEdit = false;
        }
      },
    },

    backToDeliveries: {
      reducer(state, action) {
        state.isShowFail = false;
        state.isEdit = false;
        state.form.phone = "";
        state.form.phone2 = "";
        state.form.userName = "";
        state.form.comments = "";
        state.form.deliveryTime = "";
        state.elementIndex = action.payload;
      },
    },

    showApprovePopupBusiness: {
      reducer(state, action) {
        state.isApprovePopupShowBusiness = action.payload;
      },
    },
    setSavedSuccessfullyVisible: {
      reducer(state, action) {
        state.isSavedSuccessfullyVisible = action.payload;
      },
    },
  },
  extraReducers: {
    [updateOrCancel.fulfilled]: (state, action) => {
      state.updateSuccess = "";
      if (action.payload.Body.updateStatus) {
        state.updateSuccess = action.payload.Body.updateStatus;
        state.isSavedSuccessfullyVisible = true;
      } else {
        state.updateSuccess = false;
        state.isShowFail = true;
      }
    },
    [updateOrCancel.rejected]: (state, action) => {
      state.updateSuccess = "";
      state.isShowFail = true;
    },

    [getDeliveryNoProducts.fulfilled]: (state, action) => {
      if (
        action.payload.message !== "" &&
        action.payload.message != undefined
      ) {
        state.form.errorObj = { errorId: 19, message: action.payload.message };
      }

      if (
        action.payload.errorCode != undefined &&
        action.payload.errorCode == 1200
      ) {
        state.form.errorObj = { errorId: 20, message: action.payload.message };
      }

      try {
        state.deliveryTimeSlots = formatDeliveryTimeSlots(action.payload.Body);
      } catch (error) {
        state.form.errorObj = { errorId: 20, message: action.payload.message };
      }
      state.form.isLoading = false;
      if (state.form.deliveryTime) {
        state.form.deliveryTime = "";
        state.form.deliveryTimePlaceholder = "בחר מועד";
      }
    },
  },
});

export const {
  deliveryValidateHandler,
  clearTimeSlots,
  setIsNewAddress,
  startLoading,
  deliveryChangeHandler,
  changeHandler,
  expandElement,
  enableEdit,
  populateForm,
  setUpdateOrCancelMode,
  showApprovePopupBusiness,
  clearValid,
  backToDeliveries,
  setSavedSuccessfullyVisible,
  setIsShowFail,
  endProcess,
} = UpdateBusinessDeliverySlotSlice.actions;

export default UpdateBusinessDeliverySlotSlice.reducer;
